import { useScript } from "@bokio/hooks/useScript/useScript";

export const MetaPixel = () => {
	useScript("scripts/metaPixel.js");

	return null;
};
